import { FC, ReactNode } from "react";
import { Link } from "react-router-dom";

import __ from "web/Layout/Translations";

import ArrowLeftIcon from "web/assets/icons/arrow-left.svg";
import ArrowRightIcon from "web/assets/icons/arrow-right.svg";

import type { ICategory } from "web/types/Category";

import classes from "./list.scss";
import getLink from "./utils/getLink";
import getParentCategoryId from "./utils/getParentCategoryId";

interface ISubcategoryViewProps {
  startCategoryData: ICategory;
  rootCategoryId: number;
  listItems: ReactNode[];
  onBack: (parentId: number | null) => void;
  onNavigate: () => void;
}

const SubcategoryView: FC<ISubcategoryViewProps> = ({
  startCategoryData,
  rootCategoryId,
  listItems,
  onBack,
  onNavigate,
}) => {
  const handleBackClick = () => {
    const parentId = getParentCategoryId(startCategoryData, rootCategoryId);
    onBack(parentId);
  };

  return (
    <div className={classes.subcategoryRoot}>
      <div className={classes.subcategory}>
        <button
          className={classes.subcategoryHeader}
          type="button"
          onClick={handleBackClick}
        >
          <ArrowLeftIcon width={10} />
          <span>{startCategoryData.name}</span>
        </button>
        <Link
          className={classes.navItem}
          to={getLink(startCategoryData.request_path)}
          onClick={onNavigate}
        >
          <span>{__("Wszystkie w ") + startCategoryData.name}</span>
          <ArrowRightIcon width={10} />
        </Link>
        {listItems}
      </div>
    </div>
  );
};

export default SubcategoryView;
